var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessControl(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 364,
    viewBox: "0 0 411 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.197 181.03V120.984C134.197 115.711 138.476 111.432 143.749 111.432H205.556",
    stroke: "#481EC0",
    strokeWidth: 4.62051,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.779 182.932V239.446C273.779 244.723 269.505 248.997 264.23 248.997H205.586",
    stroke: "#481EC0",
    strokeWidth: 4.62051,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.736 129.809C147.697 129.809 154.962 122.545 154.962 113.583C154.962 104.622 147.697 97.3577 138.736 97.3577C129.775 97.3577 122.511 104.622 122.511 113.583C122.511 122.545 129.775 129.809 138.736 129.809Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.770085,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.024 224.207C151.414 221.146 154.923 212.674 151.862 205.285C148.801 197.895 140.329 194.386 132.939 197.447C125.549 200.508 122.04 208.98 125.101 216.369C128.162 223.759 136.634 227.268 144.024 224.207Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.770085,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.726 266.158C281.688 266.158 288.952 258.893 288.952 249.932C288.952 240.971 281.688 233.706 272.726 233.706C263.765 233.706 256.501 240.971 256.501 249.932C256.501 258.893 263.765 266.158 272.726 266.158Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.770085,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.704 181.033H77.6208C73.8185 181.033 70.7362 184.115 70.7362 187.917V290.174C70.7362 293.976 73.8185 297.059 77.6208 297.059H198.704C202.506 297.059 205.588 293.976 205.588 290.174V187.917C205.588 184.115 202.506 181.033 198.704 181.033Z",
    stroke: "#481EC0",
    strokeWidth: 4.62051,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4648 273.61H205.609",
    stroke: "#481EC0",
    strokeWidth: 4.62051,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.689 297.059L163.234 315.926C163.897 317.384 162.829 319.039 161.23 319.039H113.916C112.286 319.039 111.22 317.33 111.939 315.864L121.18 297.059",
    stroke: "#481EC0",
    strokeWidth: 4.62051,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M333.524 44.9252H212.441C208.639 44.9252 205.556 48.0075 205.556 51.8097V154.067C205.556 157.869 208.639 160.951 212.441 160.951H333.524C337.326 160.951 340.408 157.869 340.408 154.067V51.8097C340.408 48.0075 337.326 44.9252 333.524 44.9252Z",
    stroke: "#481EC0",
    strokeWidth: 4.62051,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M206.25 137.502H340.43",
    stroke: "#481EC0",
    strokeWidth: 4.62051,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M289.506 160.954L298.051 179.821C298.713 181.279 297.645 182.935 296.046 182.935H248.732C247.102 182.935 246.037 181.225 246.756 179.759L255.997 160.954",
    stroke: "#481EC0",
    strokeWidth: 4.62051,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.375 259.686C108.587 243.699 121.922 231.193 137.755 230.978C153.896 230.759 167.735 243.386 168.972 259.686H107.375Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.770085,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M274.913 64.267C283.641 64.267 290.726 71.3517 290.726 80.0794V108.018C290.726 114.659 285.335 120.049 278.694 120.049H271.132C264.491 120.049 259.101 114.659 259.101 108.018V80.0794C259.101 71.3517 266.186 64.267 274.913 64.267Z",
    stroke: "#481EC0",
    strokeWidth: 4.62051,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M252.629 86.8689H295.867C297.736 86.8689 299.253 88.386 299.253 90.2547V123.866C299.253 125.735 297.736 127.252 295.867 127.252H252.629C250.76 127.252 249.243 125.735 249.243 123.866V90.2547C249.243 88.386 250.76 86.8689 252.629 86.8689Z",
    fill: "#67DC7A",
    stroke: "#262626",
    strokeWidth: 0.770085,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessControl);
export default __webpack_public_path__ + "static/media/accessControl.ec647cbf8c370f66062178195883c7d9.svg";
export { ForwardRef as ReactComponent };